import * as types from 'modules/selfServices/actionTypes';
import { createReducer } from 'utils/ReduxUtils';

/** @type {import('modules/selfServices/types').SelfService} */
export const initialState = null;

const reset = () => initialState;

const onModalReady = (_, { payload: model }) => model ?? initialState;

export default createReducer(initialState, {
  [types.SEND_CHECKOUT_READY]: onModalReady,
  [types.OPEN_SEND_WIZARD]: reset,
  [types.CLOSE_SEND_WIZARD]: reset,
});
